import { render } from "./msgItemShell.vue?vue&type=template&id=6bfee966&scoped=true"
import script from "./msgItemShell.vue?vue&type=script&lang=js"
export * from "./msgItemShell.vue?vue&type=script&lang=js"

import "./msgItemShell.vue?vue&type=style&index=0&id=6bfee966&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfee966"]])

export default __exports__